import Immutable from 'seamless-immutable';
import { RESET_CUSTOMER_RECOVERABLE } from '../actions/customer.actions';
import * as DiscountActions from '../actions/discount.actions';
export var INITIAL_STATE = Immutable({
  discountForm: {
    selectedDiscounts: null,
    discountReason: null
  },
  isFetchingDiscountContext: false,
  qualifiedDiscretionaryDiscounts: []
});
export default function DiscountReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case DiscountActions.CLEAR_DISCOUNT_FORM:
    case DiscountActions.SET_DISCOUNT_FORM:
      return state.set('discountForm', payload);
    case DiscountActions.RETRIEVE_DISCOUNT_CONTEXT.BEGIN:
      return state.set('isFetchingDiscountContext', true).set('qualifiedDiscretionaryDiscounts', []);
    case DiscountActions.RETRIEVE_DISCOUNT_CONTEXT.SUCCESS:
      return state.set('isFetchingDiscountContext', false).set('qualifiedDiscretionaryDiscounts', payload.DiscretionaryDiscounts || []);
    case DiscountActions.RETRIEVE_DISCOUNT_CONTEXT.FAILURE:
      return state.set('isFetchingDiscountContext', false).set('qualifiedDiscretionaryDiscounts', []);
    case DiscountActions.CLEAR_DISCOUNT_CONTEXT:
      return state.set('isFetchingDiscountContext', false).set('qualifiedDiscretionaryDiscounts', []);
    case RESET_CUSTOMER_RECOVERABLE:
      return INITIAL_STATE;
    default:
      return state;
  }
}